import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcel, getPoliciesDiscounts } from '@/api/policies-discounts';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import { getRanges } from '@/api/ranges';
import { getDealersRoles } from '@/api/dealers-roles';
import { searchProducts } from '@/api/products';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.policyId = 0;
    this.rangeList = [];
    this.roleList = [];
    this.productList = [];
    this.productIdRowsCount = {};
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      policyId: this.policyId,
      dealersRoleId: undefined,
      rangeId: undefined,
      productId: undefined,
      sort: ['productId,ASC', 'productsVariation.name,ASC'],
      filter: {
        enabled: '$eq',
        policyId: '$eq',
        dealersRoleId: '$eq',
        rangeId: '$eq',
        productId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.policyId = parseInt(this.$route.params && this.$route.params.policyId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
    this.fetchRanges();
    this.fetchDealersRoles();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.policyId = this.policyId;
      if (this.listQuery.dealersRoleId) {
        const data = await getPoliciesDiscounts(getQuery(this.listQuery));
        /* find out product id rows count & assign to find product id row */
        this.productIdRowsCount = {};
        data.data.forEach(item => {
          if (this.productIdRowsCount[item.productId]) {
            this.productIdRowsCount[item.productId] += 1;
          } else {
            this.productIdRowsCount[item.productId] = 1;
          }
        });
        this.list = data.data;
        this.total = data.total;
      } else {
        this.list = [];
        this.total = 0;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  doProductRowSpan(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    if ([2, 5].includes(columnIndex) && row.productId) {
      // check row - 1 has same product id
      if (rowIndex > 0) {
        const prevRow = this.list[rowIndex - 1];
        if (prevRow.productId === row.productId) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      return {
        rowspan: this.productIdRowsCount[row.productId],
        colspan: 1
      };
    }
    return 0;
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const query = this.listQuery;
      const blob = await downloadExcel({
        query
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'policies-discount.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'PoliciesDiscountList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;